import { render } from "./SingleCasesStudyFour.vue?vue&type=template&id=1b951022&scoped=true"
import script from "./SingleCasesStudyFour.vue?vue&type=script&lang=js"
export * from "./SingleCasesStudyFour.vue?vue&type=script&lang=js"

import "./SingleCasesStudyFour.vue?vue&type=style&index=0&id=1b951022&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b951022"]])

export default __exports__